import React, { Fragment } from "react";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import { compose } from "redux";

import singleRegistryTheme from "../../../components/single-registry/theme";
import {
  getSolutions,
  getSolutionsCodes,
  uploadFileVehicles,
  importVehicleBatch,
  discardUpload,
} from "../../../services/api/hubcatalog/single-registry-service";
import Loader from "../../../helpers/loader-full";
import HUBContext from "../../../services/HUBContext";
import { SingleRegistryView } from "../../../components/single-registry/view/SingleRegistryView";
import SolutionStep from "../../../components/single-registry/solutions/SolutionStep";
import UploadFile from "../../../components/single-registry/upload/UploadFile/UploadFile";
import UploadFileResume from "../../../components/single-registry/upload/UploadFileResume";
import { injectIntl, defineMessages } from "react-intl";
import { uploadStatusEnum } from "../../../components/single-registry/enums/status-upload";
import NavigationConfirmationModal from "../../../components/single-registry/modals/NavigationConfirmationModal";
import {
  trackEvent,
  trackException,
} from "../../../services/telemetry/appInsights";
import UploadFileConclusion from "../../../components/single-registry/upload/UploadFileConclusion/UploadFileConclusion";
import { solutionsEnum } from "../../../components/single-registry/enums/solutions";

export const defaultIntlMessages = defineMessages({
  title: {
    id: "vehicle.single.registry.upload.title",
    defaultMessage: "Vehicle upload",
  },
  stepperSolutions: {
    id: "vehicle.single.registry.upload.stepper.solutions",
    defaultMessage: "Solutions",
  },
  stepperUpload: {
    id: "vehicle.single.registry.upload.stepper.upload",
    defaultMessage: "Upload",
  },
  stepperReview: {
    id: "vehicle.single.registry.upload.stepper.review",
    defaultMessage: "Review",
  },
  stepperConclusion: {
    id: "vehicle.single.registry.upload.stepper.conclusion",
    defaultMessage: "Conclusion",
  },
  actionCancel: {
    id: "app.cancel",
    defaultMessage: "Cancel",
  },
  actionReturn: {
    id: "app.return",
    defaultMessage: "Back",
  },
  actionReturnToHome: {
    id: "app.returnHome",
    defaultMessage: "Back to home",
  },
  actionReturnToVehicles: {
    id: "app.returnVehicles",
    defaultMessage: "Go to Vehicles",
  },
  actionContinue: {
    id: "app.continue",
    defaultMessage: "Continue",
  },
  actionRedoUpload: {
    id: "vehicle.single.registry.upload.action.redoUpload",
    defaultMessage: "Re-upload",
  },
  continueDisabledTooltip: {
    id: "vehicle.single.registry.upload.tooltip.continueDisabled",
    defaultMessage:
      "Select at least one customer code in the selected solutions to continue.",
  },
  continueResumeUploadDisabledTooltip: {
    id: "vehicle.single.registry.upload.tooltip.continueResumeDisabled",
    defaultMessage: "Fix all errors and re-upload the file.",
  },
  uploadModalTitle: {
    id: "vehicle.single.registry.upload.confirmationModal.title",
    defaultMessage: "Ao voltar, o upload será descartado",
  },
  uploadModalMessage: {
    id: "vehicle.single.registry.upload.confirmationModal.message",
    defaultMessage:
      "Se voltar agora, o arquivo não será salvo e você terá de reenviá-lo depois.",
  },
  uploadModalStay: {
    id: "vehicle.single.registry.upload.confirmationModal.stay",
    defaultMessage: "Permanecer aqui",
  },
  uploadModalReturn: {
    id: "vehicle.single.registry.upload.confirmationModal.return",
    defaultMessage: "Voltar e descartar",
  },
});

export class VehicleSingleRegistryUploadBase extends React.Component {
  includeDefaultSolution = true;
  state = {
    isLoading: false,
    solutionsCodesSelected: new Map(),
    activeSolutions: new Set([solutionsEnum.GOHUB]),
    uploadedFile: null,
    modalConfirmDiscardUploadedFile: {
      isOpen: false,
      isButtonReturn: false,
    },
    hasErrorUpload: false,
    uploadErrorMessage: "",
    percent: 0,
    status: uploadStatusEnum.STOPPED,
    allSolutions: [],
    modalConfirmAction: () => {},
    isConfirmationModalOpen: false,
    resumeUploadFileResponse: null,
    companyUploadId: null,
    disableResumeUploadButton: false,
  };

  solutionStep() {
    return {
      id: 0,
      label: this.props.intl.formatMessage(
        defaultIntlMessages.stepperSolutions,
      ),
      actions: {
        return: {
          onClick: this.handleBackToVehicleModuleClick.bind(this),
        },
        prev: {
          text: this.props.intl.formatMessage(defaultIntlMessages.actionCancel),
          onClick: this.handleCancelClick.bind(this),
        },
        next: {
          text: this.props.intl.formatMessage(
            defaultIntlMessages.actionContinue,
          ),
          disabledTooltip: this.props.intl.formatMessage(
            defaultIntlMessages.continueDisabledTooltip,
          ),
          isDisabled: () => {
            for (const solutionId of this.state.activeSolutions) {
              const solution = this.state.allSolutions.find(
                (s) => s.id === solutionId,
              );

              if (
                solutionId === solutionsEnum.GOHUB ||
                solution?.code === solutionsEnum.TTOLL
              ) {
                continue;
              }

              const selectedCodes =
                this.state.solutionsCodesSelected.get(solutionId);

              if (!selectedCodes || selectedCodes.length === 0) {
                return true;
              }
            }
            return false;
          },
        },
      },
      component: (
        <SolutionStep
          includeDefaultSolution={this.includeDefaultSolution}
          solutionsSelected={this.state.solutionsSelected}
          solutionsCodesSelected={this.state.solutionsCodesSelected}
          getSolutions={this.solutions}
          getSolutionsCodes={this.solutionsCodes}
          onSolutionsCodesChanges={this.setSolutionsCodes.bind(this)}
          onSolutionToggle={this.handleSolutionToggle.bind(this)}
        />
      ),
    };
  }

  uploadStep() {
    return {
      id: 1,
      label: this.props.intl.formatMessage(defaultIntlMessages.stepperUpload),
      actions: {
        return: {
          onClick: this.handleReturnClickStepUpload.bind(this),
        },
        prev: {
          text: this.props.intl.formatMessage(defaultIntlMessages.actionReturn),
          onClick: this.handlePrevClickStepUpload.bind(this),
        },
        next: {
          isDisabled: this.handleDisableButtonContinueUploadFile,
          text: this.props.intl.formatMessage(
            defaultIntlMessages.actionContinue,
          ),
          onClick: async () => this.uploadFileVehiclesHandler(),
          disabledTooltip: this.state.hasErrorUpload
            ? this.state.uploadErrorMessage
            : "Selecione um arquivo para upload",
        },
      },
      component: (
        <UploadFile
          onFileChange={this.handleFileChange.bind(this)}
          hasErrorUpload={this.state.hasErrorUpload}
          uploadErrorMessage={this.state.uploadErrorMessage}
          percent={this.state.percent}
          status={this.state.status}
          companyId={this.props?.match?.params.cid}
          integratorsSolutionsCode={this.getIntegratorSolutionCodes()}
        />
      ),
    };
  }

  resumeStep() {
    return {
      id: 2,
      label: this.props.intl.formatMessage(defaultIntlMessages.stepperReview),
      component: (
        <UploadFileResume
          companyId={this.props?.match?.params.cid}
          integratorsSolutionsCode={this.getIntegratorSolutionCodes()}
          dataTable={this.state.resumeUploadFileResponse}
          companyUploadId={this.state.companyUploadId}
        />
      ),
      actions: {
        return: {
          onClick: this.handleReturnClickStepUpload.bind(this),
        },
        prev: {
          text: this.props.intl.formatMessage(
            defaultIntlMessages.actionRedoUpload,
          ),
          onClick: this.handleRedoUploadFromResumeClick.bind(this),
        },
        next: {
          isDisabled: this.isResumeStepContinueButtonDisabled,
          text: this.props.intl.formatMessage(
            defaultIntlMessages.actionContinue,
          ),
          onClick: async () => this.handleImportVehicleBatch(),
          disabledTooltip: this.state.hasErrorUpload
            ? this.props.intl.formatMessage(
                defaultIntlMessages.continueResumeUploadDisabledTooltip,
              )
            : "",
        },
      },
    };
  }

  conclusionStep() {
    return {
      id: 3,
      label: this.props.intl.formatMessage(
        defaultIntlMessages.stepperConclusion,
      ),
      isSuccess: true,
      component: (
        <UploadFileConclusion
          itemsChanged={this.state.resumeUploadFileResponse?.data?.length}
          hasSolutions={this.state.solutionsCodesSelected.size > 0}
        />
      ),
      actions: {
        return: {
          onClick: this.handleBackToVehicleModuleClick.bind(this),
        },
        prev: {
          text: this.props.intl.formatMessage(
            defaultIntlMessages.actionReturnToHome,
          ),
          onClick: this.handleReturnHomeClick.bind(this),
          isShow: true,
        },
        next: {
          text: this.props.intl.formatMessage(
            defaultIntlMessages.actionReturnToVehicles,
          ),
          onClick: this.handleBackToVehicleModuleClick.bind(this),
        },
      },
    };
  }

  solutionsCodes = this.getSolutionsCodesPipe().bind(this);
  solutions = this.getSolutionsPipe.bind(this);

  componentDidMount() {
    const { setCurrentDashboard, intl } = this.context;
    const companyId = this.props?.match?.params.cid;

    trackEvent("SingleRegistry_BulkUploadStarted", {
      companyId,
    });

    setCurrentDashboard(null, intl, () => {
      if (!!document.body.classList.contains("dash-v2"))
        document.body.classList.remove("dash-v2");

      if (!document.body.classList.contains("dash-v3"))
        document.body.classList.add("dash-v3");

      if (!document.body.classList.contains("no-db-body-padding"))
        document.body.classList.add("no-db-body-padding");
    });

    if (this.skipSolutions()) return;

    this.toggleLoding();
    this.getSolutionsPipe()
      .then((solutions) => {
        if (solutions) {
          this.setState({ allSolutions: solutions });
        }
      })
      .finally(() => this.toggleLoding());
  }

  skipSolutions() {
    const queries = new URLSearchParams(this.props.location.search);
    return queries.get("skip_solutions") === "true";
  }

  componentWillUnmount() {
    if (document.body.classList.contains("dash-v3"))
      document.body.classList.remove("dash-v3");

    if (document.body.classList.contains("no-db-body-padding"))
      document.body.classList.remove("no-db-body-padding");
  }

  setUploadProgress(percent, status = uploadStatusEnum.SENDING) {
    this.setState({ percent, status });
  }

  handleSolutionToggle(solutionId, isEnabled) {
    if (isEnabled) {
      this.state.activeSolutions.add(solutionId);
    } else {
      this.state.activeSolutions.delete(solutionId);
      this.state.solutionsCodesSelected.delete(solutionId);
    }
    this.setState({
      activeSolutions: this.state.activeSolutions,
      solutionsCodesSelected: this.state.solutionsCodesSelected,
    });
  }

  getVehiclesModulePath() {
    const { dashboards } = this.context;

    if (dashboards) {
      let vehiclesDashboard = (dashboards || []).find(
        (x) => x.dashboardKey === "vehicles-v2",
      );
      if (!vehiclesDashboard || vehiclesDashboard.dashboardID <= 0) {
        vehiclesDashboard = (dashboards || []).find(
          (x) => x.dashboardKey === "Vehicles",
        );
      }

      if (vehiclesDashboard?.dashboardID) {
        return `/app/${this.props?.match?.params.cid}/dash/${vehiclesDashboard.dashboardID}`;
      }
    }
  }

  getDashboardPath() {
    const { dashboards } = this.context;

    const homeDashboardID =
      (dashboards || []).find((x) => x.dashboardKey === "home")?.dashboardID ||
      0;

    return `/app/${this.props?.match?.params.cid}/dash/${homeDashboardID}`;
  }

  handleReturnHomeClick = () => {
    this.props.history.push(this.getDashboardPath());
  };

  handleCancelClick = () => {
    this.props.history.push(this.getVehiclesModulePath());
  };

  handleReturnClickStepUpload = () => {
    if (this.state.uploadedFile) {
      this.setState({
        isConfirmationModalOpen: true,
        modalConfirmAction: () => {
          this.uploadStateReset();
          this.props.history.push(this.getVehiclesModulePath());
        },
      });
      return;
    }

    this.props.history.push(this.getVehiclesModulePath());
  };

  uploadStateReset = () => {
    this.setState({
      uploadedFile: null,
      percent: 0,
      hasErrorUpload: false,
      uploadErrorMessage: "",
      solutionsCodesSelected: new Map(),
      activeSolutions: new Set([solutionsEnum.GOHUB]),
      status: uploadStatusEnum.STOPPED,
    });
  };

  uploadRedoStateReset = () => {
    this.setState({
      uploadedFile: null,
      percent: 0,
      hasErrorUpload: false,
      uploadErrorMessage: "",
      status: uploadStatusEnum.STOPPED,
    });
  };

  handlePrevClickStepUpload = (navigateBack) => {
    if (this.state.uploadedFile) {
      this.setState({
        isConfirmationModalOpen: true,
        modalConfirmAction: () => {
          this.navigateStepUpload(navigateBack);
        },
      });
      return;
    }

    this.navigateStepUpload(navigateBack);
  };

  handleCloseConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: false,
    });
  };

  handleConfirmNavigation = () => {
    this.state.modalConfirmAction();
    this.handleCloseConfirmationModal();
  };

  handleDisableButtonContinueUploadFile = () => !this.state.uploadedFile;

  navigateStepUpload = (navigateBack) => {
    this.uploadStateReset();

    if (!this.skipSolutions()) {
      navigateBack();
    } else {
      this.handleCancelClick();
    }
  };

  isResumeStepContinueButtonDisabled = () => {
    const { resumeUploadFileResponse } = this.state;
    return (
      !resumeUploadFileResponse?.data ||
      resumeUploadFileResponse.data.some(
        (row) =>
          row.errors &&
          Object.values(row.errors).some(
            (error) => error && Object.keys(error).length > 0,
          ),
      )
    );
  };

  isSolutionActive(solutionCode) {
    if (!this.state?.activeSolutions?.size) {
      return false;
    }

    for (const solutionId of this.state.activeSolutions) {
      const solution = this.state.allSolutions.find((s) => s.id === solutionId);

      if (solution && solution.code === solutionCode) {
        return true;
      }
    }

    return false;
  }

  pushSolutionWithoutIntegratorCode(solutionCode, integratorSolutionCodes) {
    integratorSolutionCodes.push({ solutionCode, integratorCode: [] });
  }

  getIntegratorSolutionCodes() {
    const integratorSolutionCodes = [];
    for (const [solutionId, integratorCodes] of this.state
      .solutionsCodesSelected) {
      const solution = this.state.allSolutions.find((s) => s.id === solutionId);
      if (solution) {
        integratorSolutionCodes.push({
          solutionCode: solution.code,
          integratorCode: integratorCodes,
        });
      }
    }

    if (this.isSolutionActive(solutionsEnum.TTOLL)) {
      this.pushSolutionWithoutIntegratorCode(
        solutionsEnum.TTOLL,
        integratorSolutionCodes,
      );
    }

    return integratorSolutionCodes;
  }

  getSteppers() {
    const steppers = [
      this.solutionStep(),
      this.uploadStep(),
      this.resumeStep(),
      this.conclusionStep(),
    ];
    if (this.skipSolutions()) {
      steppers.shift();
      return steppers.map((item, i) => ({
        ...item,
        id: i,
      }));
    }
    return steppers;
  }

  async getSolutionsPipe() {
    try {
      const solutions = await getSolutions(this.props?.match?.params.cid);
      return solutions.data;
    } catch (error) {
      return [];
    }
  }

  setSolutionsCodes(solution) {
    if (solution && solution.codes.length > 0) {
      this.state.solutionsCodesSelected.set(
        solution.solutionId,
        solution.codes,
      );
    } else if (solution) {
      this.state.solutionsCodesSelected.delete(solution.solutionId);
    }
    this.setState({
      solutionsCodesSelected: this.state.solutionsCodesSelected,
    });
  }

  getSolutionsCodesPipe() {
    const companyId = this.props?.match?.params.cid;
    return async (integratorSolutionId) => {
      this.toggleLoding();
      try {
        const res = await getSolutionsCodes(companyId, integratorSolutionId);
        return res.data;
      } catch (error) {
        return [];
      } finally {
        this.toggleLoding();
      }
    };
  }

  async uploadFileVehiclesHandler() {
    const integratorSolutionCodes = [];
    for (const [solutionId, integratorCodes] of this.state
      .solutionsCodesSelected) {
      const solution = this.state.allSolutions.find((s) => s.id === solutionId);
      if (solution) {
        integratorSolutionCodes.push({
          solutionCode: solution.code,
          integratorCode: integratorCodes,
        });
      }
    }

    const companyId = this.props?.match?.params.cid;
    const solutionCodesSerialized = JSON.stringify({ integratorSolutionCodes });

    this.toggleLoding();

    this.setState({
      status: uploadStatusEnum.SENDING,
      percent: 0,
      hasErrorUpload: false,
      uploadErrorMessage: "",
    });

    const formData = new FormData();
    formData.append("file", this.state.uploadedFile);
    formData.append(
      "integratorSolutionCodesSerialized",
      solutionCodesSerialized,
    );
    try {
      const res = await uploadFileVehicles(
        companyId,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (e) => {
            if (e.total) {
              const percent = Math.round((e.loaded * 100) / e.total);
              this.setState({ percent, status: "sending" });
            }
          },
        },
        this.context.locale,
      );

      trackEvent("SingleRegistry_FileUploadCompleted", {
        companyId,
        hasError: res.data.hasError,
        vehicleCount: res.data?.data?.length || 0,
        errorMessage: res.data.errorMessage,
      });

      this.setState({
        percent: 100,
        status: uploadStatusEnum.COMPLETED,
        hasErrorUpload: res.data.hasError,
        uploadErrorMessage: res.data.errorMessage,
        resumeUploadFileResponse: res.data,
        companyUploadId: res.data.companyUploadId,
      });
      return true;
    } catch (error) {
      const errorMessage = error?.response?.data ?? error?.message;

      trackException(error, {
        companyId,
        action: "uploadFileVehicles",
        errorStatus: error.response?.status,
        errorDetails:
          typeof errorMessage === "string"
            ? errorMessage
            : JSON.stringify(errorMessage),
      });

      this.setState({
        uploadedFile: null,
        percent: 0,
        status: uploadStatusEnum.STOPPED,
        hasErrorUpload: true,
        uploadErrorMessage:
          typeof errorMessage === "string"
            ? errorMessage
            : JSON.stringify(errorMessage),
      });
    } finally {
      this.toggleLoding();
    }
  }

  async handleImportVehicleBatch() {
    this.toggleLoding();

    const companyId = this.props?.match?.params.cid;
    const { companyUploadId } = this.state;

    const payload = {
      companyUploadId: companyUploadId,
    };

    try {
      const result = await importVehicleBatch(companyId, payload);

      trackEvent("SingleRegistry_ImportBatchCompleted", {
        companyId,
        companyUploadId,
      });

      return result;
    } catch (error) {
      trackException(error, {
        companyId,
        action: "importVehicleBatch",
        companyUploadId,
        errorStatus: error.response?.status,
      });

      if (this.props?.alert && typeof this.props.alert.error === "function") {
        this.props.alert.error(error?.response?.data);
      }
    } finally {
      this.toggleLoding();
    }
  }

  handleFileChange(file) {
    trackEvent("SingleRegistry_FileSelected", {
      companyId: this.props?.match?.params.cid,
      fileName: file?.name,
      fileSize: file?.size,
    });

    this.setState({
      uploadedFile: file,
      hasErrorUpload: false,
      uploadErrorMessage: "",
      percent: 0,
      status: uploadStatusEnum.STOPPED,
    });
  }

  toggleLoding() {
    this.setState({
      isLoading: !this.state.isLoading,
    });
  }

  handleRedoUploadClick = (navigateBack) => {
    this.setState({
      isConfirmationModalOpen: true,
      modalConfirmAction: () => {
        this.uploadStateReset();
        navigateBack();
      },
    });
  };

  handleRedoUploadFromResumeClick = (navigateBack) => {
    this.setState({
      isConfirmationModalOpen: true,
      modalConfirmAction: () => {
        this.handlediscardUpload();
        this.uploadRedoStateReset();
        navigateBack();
      },
    });
  };

  handleBackToVehicleModuleClick = (_) => {
    this.uploadStateReset();
    this.props.history.push(this.getVehiclesModulePath());
  };

  async handlediscardUpload() {
    const companyId = this.props?.match?.params.cid;
    let { companyUploadId } = this.state;

    if (companyUploadId !== 0 || !companyUploadId)
      await discardUpload(companyId, companyUploadId);
  }
}

export class VehicleSingleRegistryUpload extends VehicleSingleRegistryUploadBase {
  render() {
    const { intl } = this.props;
    return (
      <ThemeProvider theme={singleRegistryTheme}>
        <Fragment>
          {this.state.isLoading && <Loader full={true} />}
          <SingleRegistryView
            stepClickDisabled={true}
            modulePath="/vehicles"
            hasHeader={true}
            headerTitle={
              intl.formatMessage(defaultIntlMessages.title) ?? "Default"
            }
            steppers={this.getSteppers()}
          />
          <NavigationConfirmationModal
            open={this.state.isConfirmationModalOpen}
            title={intl.formatMessage(defaultIntlMessages.uploadModalTitle)}
            message={intl.formatMessage(defaultIntlMessages.uploadModalMessage)}
            primaryButtonText={intl.formatMessage(
              defaultIntlMessages.uploadModalStay,
            )}
            secondaryButtonText={intl.formatMessage(
              defaultIntlMessages.uploadModalReturn,
            )}
            onPrimaryClick={this.handleCloseConfirmationModal.bind(this)}
            onSecondaryClick={this.handleConfirmNavigation.bind(this)}
          />
        </Fragment>
      </ThemeProvider>
    );
  }
}

VehicleSingleRegistryUpload.contextType = HUBContext;
export default compose(
  withRouter,
  injectIntl,
  withAlert(),
)(VehicleSingleRegistryUpload);
